<script>
import { Line, mixins } from 'vue-chartjs'

export default {
  extends: Line,
  mixins: [mixins.reactiveProp],
  props: {
    chartData: {
      type: Object,
      default: null
    },
    options: {
      type: Object,
      default: null
    }
  },

  mounted () {
    this.$events.listen('updateChart', eventData => this.updateChart())
    this.renderChart(this.chartData, this.options)
  },

  methods: {
    updateChart: function(event) {
	this.$nextTick(() => {
        if (this.$data._chart) {
            this.$data._chart.destroy()
            this.$emit('chart:destroy')
        }
        this.renderChart(this.chartData, this.options)
        this.$emit('chart:render')
	});
    }
  }

}
</script>
